import React, { Fragment } from 'react';

import Navbar from '../components/header/Navbar';
import PortfolioContent from '../components/PortfolioContent';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const ServicePage = () => {
    return (
        <Fragment>
            <Navbar />
            <PortfolioContent />
            <ContactUs />
            <Footer />
        </Fragment>
    );
}

export default ServicePage;
